import React, { useState, useEffect } from "react";

export default function MYSQLtest(props) {
  const correctAnswers = [2, 0, 1, 1, 1, 2, 0, 2, 2, 0, 0, 0, 0, 2, 0, 0, 0, 3, 1, 2, 0, 0, 2, 2, 0];
  const que = {
    q1: {
      string: "1. Which statement is used to retrieve data from a database in MySQL?",
      options: ["FETCH", "GET", "SELECT", "RETRIEVE"],
      ans: 2
    },
    q2: {
      string: "2. Which command is used to delete a table in MySQL?",
      options: ["DROP TABLE", "DELETE TABLE", "REMOVE TABLE", "REMOVE"],
      ans: 0
    },
    q3: {
      string: "3. Which keyword is used to retrieve only unique records in a SELECT query in MySQL?",
      options: ["UNIQUE", "DISTINCT", "UNIQUERECORDS", "ONLYUNIQUE"],
      ans: 1
    },
    q4: {
      string: "4. In MySQL, which data type would you use to store a date?",
      options: ["DATETIME", "DATE", "TIMESTAMP", "TIME"],
      ans: 1
    },
    q5: {
      string: "5. Which statement is used to update data in a MySQL database?",
      options: ["CHANGE", "UPDATE", "MODIFY", "ALTER"],
      ans: 1
    },
    q6: {
      string: "6. What does SQL stand for?",
      options: ["Structured Question Language", "Simple Query Language", "Structured Query Language", "Sequential Query Language"],
      ans: 2
    },
    q7: {
      string: "7. Which function is used to return the current date and time in MySQL?",
      options: ["NOW()", "CURRENT_DATE()", "GETDATE()", "TODAY()"],
      ans: 0
    },
    q8: {
      string: "8. Which statement is used to insert new records into a MySQL table?",
      options: ["ADD", "CREATE", "INSERT", "NEW"],
      ans: 2
    },
    q9: {
      string: "9. In MySQL, what is the purpose of the GROUP BY clause?",
      options: ["To order the results", "To filter results", "To group rows that have the same values", "To perform arithmetic operations"],
      ans: 2
    },
    q10: {
      string: "10. Which operator is used to compare two values for equality in MySQL?",
      options: ["=", "==", "<>", "!="],
      ans: 0
    },
    q11: {
      string: "11. Which command is used to change the structure of a table in MySQL?",
      options: ["ALTER TABLE", "CHANGE TABLE", "MODIFY TABLE", "UPDATE TABLE"],
      ans: 0
    },
    q12: {
      string: "12. In MySQL, which keyword is used to sort the result-set in ascending order?",
      options: ["ASC", "DESC", "SORT", "ORDER"],
      ans: 0
    },
    q13: {
      string: "13. What does the WHERE clause do in a MySQL SELECT statement?",
      options: ["Filters rows based on specified conditions", "Sorts the result-set in ascending order", "Joins two or more tables", "None of the above"],
      ans: 0
    },
    q14: {
      string: "14. Which command is used to create a new database in MySQL?",
      options: ["NEW DATABASE", "ADD DATABASE", "CREATE DATABASE", "MAKE DATABASE"],
      ans: 2
    },
    q15: {
      string: "15. Which statement is used to remove a row from a MySQL table?",
      options: ["DELETE", "REMOVE", "DROP", "ERASE"],
      ans: 0
    },
    q16: {
      string: "16. Which function is used to count the number of rows in a MySQL table?",
      options: ["COUNT()", "NUMROWS()", "ROWS()", "TOTALROWS()"],
      ans: 0
    },
    q17: {
      string: "17. In MySQL, which function is used to concatenate two or more strings?",
      options: ["CONCAT()", "JOIN()", "MERGE()", "APPEND()"],
      ans: 0
    },
    q18: {
      string: "18. Which statement is used to grant privileges in MySQL?",
      options: ["GRANT PRIVILEGES", "SET PRIVILEGES", "ADD PRIVILEGES", "GRANT"],
      ans: 3
    },
    q19: {
      string: "19. Which function is used to retrieve the current user's ID in MySQL?",
      options: ["USERID()", "CURRENT_USER()", "GETID()", "ID()"],
      ans: 1
    },
    q20: {
      string: "20. In MySQL, which operator is used to check if a value exists in a set of values?",
      options: ["BETWEEN", "LIKE", "IN", "EXISTS"],
      ans: 2
    },
    q21: {
      string: "21. Which statement is used to return the first n characters in a string in MySQL?",
      options: ["LEFT()", "SUBSTRING()", "FIRST()", "START()"],
      ans: 0
    },
    q22: {
      string: "22. In MySQL, what is the purpose of the HAVING clause?",
      options: ["To order the results", "To filter results", "To group rows that have the same values", "To perform arithmetic operations"],
      ans: 3
    },
    q23: {
      string: "23. Which statement is used to remove a database in MySQL?",
      options: ["DELETE DATABASE", "REMOVE DATABASE", "DROP DATABASE", "ERASE DATABASE"],
      ans: 2
    },
    q24: {
      string: "24. Which function is used to find the largest value in a MySQL table?",
      options: ["LARGEST()", "BIGGEST()", "MAX()", "GREATEST()"],
      ans: 2
    },
    q25: {
      string: "25. In MySQL, which statement is used to create a view?",
      options: ["CREATE VIEW", "MAKE VIEW", "VIEW CREATE", "NEW VIEW"],
      ans: 0
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>MYSQL <span>Skill</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
